import React from 'react';

const IconMap = ({ onClick }) => {
	return (
		<div className='IconMap' onClick={onClick}>
			<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clipPath="url(#clip0_408_944)">
					<path d="M17.0833 2.5L16.95 2.525L12.5 4.25L7.5 2.5L2.8 4.08333C2.625 4.14167 2.5 4.29167 2.5 4.48333V17.0833C2.5 17.3167 2.68333 17.5 2.91667 17.5L3.05 17.475L7.5 15.75L12.5 17.5L17.2 15.9167C17.375 15.8583 17.5 15.7083 17.5 15.5167V2.91667C17.5 2.68333 17.3167 2.5 17.0833 2.5ZM12.5 15.8333L7.5 14.075V4.16667L12.5 5.925V15.8333Z" fill="#344054" />
				</g>
				<defs>
					<clipPath id="clip0_408_944">
						<rect width="20" height="20" fill="white" />
					</clipPath>
				</defs>
			</svg>
		</div>
	)
}

export default IconMap;